import en from './en.json';
import sm from './sm.json';

// Interface translations. User-generated content (recommendation names, why text,
// people's names) is never translated or altered by this module.
export const LANGUAGES = ['en', 'sm'];
export const DEFAULT_LANGUAGE = 'en';
export const STORAGE_KEY = 'irecommend-language';

const DICTIONARIES = { en, sm };

export const isLanguage = (value) => LANGUAGES.includes(value);

// Missing or untranslated keys fall back to English, so a partially translated
// dictionary can never show a raw key to a user.
export const translate = (language, key, vars) => {
  const dictionary = DICTIONARIES[language] || en;
  let text = dictionary[key] ?? en[key] ?? key;
  if (vars) {
    for (const [name, value] of Object.entries(vars)) {
      text = text.replaceAll(`{${name}}`, value);
    }
  }
  return text;
};
